import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function ArrowLineUp({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M23.5 18L15.5 12L7.5 18" stroke={color}
                strokeWidth="2" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
}

export default ArrowLineUp;
